import { combineEpics } from "redux-observable";
import auth from "./auth";
import billing from "./billing";
import contact from "./contact";
import engine from "./engine";
import keys from "./keys";
import user from "./user";
export default combineEpics(auth, billing, contact, engine, keys, user);
